export const BILLER_OR_CONTACT_ROW_ITEM_HEIGHT = 56
